import React from "react";

export default function BranchComingSoon({ title }) {
  return (
    <div className="branch-module-card">
      <div className="module-badge">STATE BRANCH MODULE</div>
      <h1>{title}</h1>
      <p>
        This module is connected with the State Branch sidebar. Detailed workflow,
        approvals, Firestore data, mail automation and reports can be added here
        without changing the main branch portal structure.
      </p>

      <div className="module-grid">
        <div><b>Live Data</b><span>Firestore connected module</span></div>
        <div><b>Branch Approval</b><span>State level control</span></div>
        <div><b>Mail Queue</b><span>Automatic notification system</span></div>
        <div><b>MIS Ready</b><span>Reports and export support</span></div>
      </div>
    </div>
  );
}